import naja from 'naja';
import ModalExtension from './../controls/modal/index';
import ConfirmDialogExtension from './../controls/confirmDialog/index';
import FormsConfirmDialogExtension from './../controls/formConfirmDialog/index';
import Select2Extension from './select2';
import FlashesExtension from "./../controls/flashes";
import BootstrapExtension from "./../controls/bootstrap";
import FormsExtension from "./../controls/forms/index";
import FileUploadExtension from "../controls/fileUpload";
import BaseGridExtension from "../controls/baseGrid";
import LoadingIndicatorExtension from "../controls/loadingIndicator";
import IframeInputExtension from "../controls/IframeInput";
import AutoFillInputExtension from "./auto-fill-input";
import DependentSelect from "../controls/dependentSelect";
import WysiwygExtension from "../controls/wysiwyg";
import CheckboxFilter from "../controls/checkboxFilter";
import CheckboxSelectAll from "../controls/checkboxSelectAll";
import VisibilityDependentInputsExtension from "@/ui/visibility-dependent-inputs";
import TimeSheetExtension from "@/controls/timeSheet";
import ContentDropdownExtension from "@/controls/contentDropdown";
import InputsValidator from "../controls/inputsValidator";
import Printer from "../controls/printer";
import LoopGuardExtension from "../controls/loopGuard";
import FreezeWatchdogExtension from "../controls/freezeWatchdog";
import DoubleSubmitGuardExtension from "../controls/doubleSubmitGuard";
import RequestScopeExtension from "../controls/requestScope";
import NavigationHistoryExtension from "../controls/navigationHistory";

const openExternalLinksInNewTab = () => {
    document.querySelectorAll('a[href^="http://"], a[href^="https://"]').forEach(link => {
        if (link.hostname !== window.location.hostname) {
            link.setAttribute('target', '_blank');
            link.setAttribute('rel', 'noopener noreferrer');
        }
    });
};

document.addEventListener('DOMContentLoaded', () => {
	naja.initialize({
		history: true,
	});
	naja.redirectHandler.addEventListener('redirect', (event) => event.detail.setHardRedirect(true));

	naja.registerExtension(new RequestScopeExtension());
	naja.registerExtension(new LoopGuardExtension());
	naja.registerExtension(new FreezeWatchdogExtension());
	naja.registerExtension(new DoubleSubmitGuardExtension());
	naja.registerExtension(new ModalExtension());
    const select2Extension = new Select2Extension();
    select2Extension.init();
    naja.registerExtension(select2Extension);
    naja.registerExtension(new IframeInputExtension());
    naja.registerExtension(new ConfirmDialogExtension());
    naja.registerExtension(new FormsConfirmDialogExtension());
    naja.registerExtension(new FlashesExtension());
    naja.registerExtension(new FormsExtension());
    naja.registerExtension(new FileUploadExtension());
    naja.registerExtension(new BaseGridExtension());
    naja.registerExtension(new LoadingIndicatorExtension());
    naja.registerExtension(new AutoFillInputExtension());
    naja.registerExtension(new VisibilityDependentInputsExtension());
    naja.registerExtension(new BootstrapExtension());
    naja.registerExtension(new DependentSelect());
    naja.registerExtension(new WysiwygExtension());
    naja.registerExtension(new CheckboxFilter());
    naja.registerExtension(new CheckboxSelectAll());
    naja.registerExtension(new TimeSheetExtension());
    naja.registerExtension(new ContentDropdownExtension());
    naja.registerExtension(new InputsValidator());
    naja.registerExtension(new Printer());
    naja.registerExtension(new NavigationHistoryExtension());

    // naja.uiHandler.addEventListener('interaction', (event) => {
    //     const {element} = event.detail;
    //     const question = element.dataset.confirm;
    //     if (question && ! window.confirm(question)) {
    //         event.preventDefault();
    //     }
    // });

    openExternalLinksInNewTab();

    naja.addEventListener('success', event => {
        openExternalLinksInNewTab();
        if (event.detail.payload.redirectNewTabUrl) {
            window.open(event.detail.payload.redirectNewTabUrl, '_blank');
        }

        $(".modal").on("shown.bs.modal", function () {
            if ($(".modal-backdrop").length > 1) {
                $(".modal-backdrop").not(':first').remove();
            }
        })

        if (event.detail.payload.showModal === false) {
            if (!$('.modal.show').length) {
                // $('.modal').modal('hide');
                $('.modal-backdrop').remove();
            }
            // naja.makeRequest('GET', {link refresh!})
        }

        if (event.detail.payload.hideModal) {
            if ($(event.detail.payload.hideModal).length) {
                $(event.detail.payload.hideModal).modal('hide');
            }
        }

        if($('.toggle-tabs').length && $('#tab-menu').hasClass('show')) {
            console.log('click');
            $('.toggle-tabs').trigger('click');
        }
    });
});
